<template>
  <ValidationObserver
    ref="observer"
    tag="form">
    <BaseTextFieldGroupWithProvider
      v-model="form.name"
      label="テンプレート名"
      name="テンプレート名"
      :response-errors="responseErrors"
      rules="required"
      vid="name" />
    <BaseTextFieldGroupWithProvider
      v-model="form.displayOrder"
      label="並び順"
      name="並び順"
      col="4"
      type="number"
      :response-errors="responseErrors"
      vid="displayOrder"
      rules="required" />
    <CaptionText class="mt-n2">
      ※テンプレートの並び順です
    </CaptionText>
    <LabelText>項目設定</LabelText>
    <CaptionText>※項目とは[技術] [スピード] [メンタル] などのジャンルです</CaptionText>
    <div class="row pb-4">
      <div class="col-5">
        <BaseSelectGroupWithProvider
          v-model="entriesCount"
          label="項目数"
          name="項目数"
          type="number"
          :disabled="isEdit"
          :options="entriesCountOptions"
          rules="required|min_value:5|max_value:8" />
        <BaseSelectGroupWithProvider
          v-model="form.actionGoalsCount"
          label="項目別行動目標数"
          name="項目別行動目標数"
          :disabled="isEdit"
          type="number"
          :options="actionGoalsCountOptions"
          :response-errors="responseErrors"
          vid="actionGoalsCount"
          rules="required" />
        <div class="mt-n2">
          <CaptionText class="text-nowrap">
            ※1つの項目にメンバーが作成できる
          </CaptionText>
          <CaptionText class="pl-2">
            行動目標の数です
          </CaptionText>
        </div>
      </div>
      <div class="col-7">
        <EmptyRadarChart
          :dimension="displayEntriesCount" />
      </div>
    </div>
    <MandalaGoalTemplateFormEntryItem
      v-for="(entry, index) in form.templateEntries"
      :key="index"
      v-model="form.templateEntries[index]"
      :action-goals-count="form.actionGoalsCount" />
    <LabelText>公開設定</LabelText>
    <CaptionText>
      ※鍵の部分は指導者だけが閲覧できます
    </CaptionText>
    <LabelText>最終目標</LabelText>
    <LockFinalGoalNameWrapper class="mb-4">
      <LockCheckButton v-model="form.isLockFinalGoal" />
    </LockFinalGoalNameWrapper>
    <div class="d-flex justify-content-center align-items-center">
      <LockCheckButton
        v-model="form.isLockEntryNames"
        class="mr-2" />
      <LabelText>項目名</LabelText>
    </div>
    <div class="pt-3 d-flex justify-content-center align-items-center">
      <LockCheckButton
        v-model="form.isLockActivityRecords"
        class="mr-2" />
      <LabelText>活動記録</LabelText>
    </div>
    <LockChartWrapper :dimension="displayEntriesCount">
      <div class="d-flex align-items-center">
        <LockCheckButton
          v-model="form.isLockChart"
          class="mr-2" />
        <LabelText>チャート</LabelText>
      </div>
    </LockChartWrapper>
    <LabelText>行動目標と自己評価</LabelText>
    <MandalaGoalTemplateFormActivityGoalItem class="mb-2">
      <template #prependName>
        <LockCheckButton
          v-model="form.isLockActionGoalNames"
          class="mr-2" />
      </template>
      <template #goalName>
        行動目標
      </template>
      <template #aboveSlider>
        <LockCheckButton
          v-model="form.isLockActionGoalScores"
          class="mr-2" />
      </template>
    </MandalaGoalTemplateFormActivityGoalItem>
    <SectionBox class="mb-2">
      <SectionBoxLabel>今月のまとめ</SectionBoxLabel>
      <div class="d-flex justify-content-center align-items-center">
        <LockCheckButton
          v-model="form.isLockSummary" />
      </div>
    </SectionBox>
    <SectionBox class="mb-2">
      <SectionBoxLabel>コメント</SectionBoxLabel>
      <div class="d-flex justify-content-center align-items-center">
        <LockCheckButton
          v-model="form.isLockComment" />
      </div>
    </SectionBox>
    <LabelText>前月の自己評価提出期限</LabelText>
    <MonthlyDeadlineDayField
      v-model="form.monthlyDeadlineDay"
      :response-errors="responseErrors"
      vid="monthlyDeadlineDay"
      class="mb-2" />
    <CaptionText>
      ※提出期限がメンバーに表示されます
    </CaptionText>
    <div class="mt-4">
      <ButtonsWrapper v-if="!isEdit || mandalaGoalTemplate === null || mandalaGoalTemplate.status === 'draft'">
        <template #leftTop>
          <BaseButton
            color="cancel"
            @click="$router.go(-1)">
            キャンセル
          </BaseButton>
        </template>
        <template #rightTop>
          <BaseButton
            @click="submit('published')">
            公開する
          </BaseButton>
        </template>
        <template #rightBottom>
          <BaseButton
            color="secondary"
            @click="submit('draft')">
            下書き保存
          </BaseButton>
        </template>
      </ButtonsWrapper>
      <ButtonsWrapper v-else-if="mandalaGoalTemplate.status === 'published'">
        <template #leftTop>
          <BaseButton
            color="cancel"
            @click="$router.go(-1)">
            キャンセル
          </BaseButton>
        </template>
        <template #rightTop>
          <BaseButton
            color="l-blue"
            @click="submit('published')">
            更新
          </BaseButton>
        </template>
        <template #rightBottom>
          <BaseButton
            @click="submit('private')">
            非公開にする
          </BaseButton>
        </template>
      </ButtonsWrapper>
      <ButtonsWrapper v-else-if="mandalaGoalTemplate.status === 'private'">
        <template #leftTop>
          <BaseButton
            color="cancel"
            @click="$router.go(-1)">
            キャンセル
          </BaseButton>
        </template>
        <template #rightTop>
          <BaseButton
            color="l-blue"
            @click="submit('private')">
            非公開
          </BaseButton>
        </template>
        <template #rightBottom>
          <BaseButton
            @click="submit('published')">
            公開する
          </BaseButton>
        </template>
      </ButtonsWrapper>
    </div>
  </ValidationObserver>
</template>

<script>
import BaseTextFieldGroupWithProvider from '@/components/parts/BaseTextFieldGroupWithProvider.vue'
import BaseSelectGroupWithProvider from '@/components/parts/BaseSelectGroupWithProvider.vue'
import BaseButton from '@/components/parts/BaseButton.vue'
import CaptionText from '@/components/parts/CaptionText.vue'
import LabelText from '@/components/parts/LabelText.vue'
import MandalaGoalTemplateFormEntryItem from '@/components/view/mandala_goal_templates/MandalaGoalTemplateFormEntryItem.vue'
import LockCheckButton from '@/components/parts/LockCheckButton.vue'
import MandalaGoalTemplateFormActivityGoalItem from './MandalaGoalTemplateFormActivityGoalItem.vue'
import LockFinalGoalNameWrapper from '@/components/view/mandala_goal_templates/LockFinalGoalNameWrapper.vue'
import MonthlyDeadlineDayField from '@/components/view/mandala_goal_templates/MonthlyDeadlineDayField.vue'
import SectionBox from '@/components/parts/SectionBox.vue'
import SectionBoxLabel from '@/components/parts/SectionBoxLabel.vue'
import ButtonsWrapper from '@/components/parts/ButtonsWrapper.vue'
import EmptyRadarChart from '@/components/charts/EmptyRadarChart.vue'
import LockChartWrapper from '@/components/view/mandala_goal_templates/LockChartWrapper.vue'
import { cloneDeep } from 'lodash'

const getDefaultForm = () => {
  return {
    name: '',
    displayOrder: 0,
    actionGoalsCount: 8,
    isLockFinalGoal: true,
    isLockEntryNames: true,
    isLockActivityRecords: true,
    isLockChart: true,
    isLockActionGoalNames: true,
    isLockActionGoalScores: true,
    isLockSummary: true,
    isLockComment: true,
    monthlyDeadlineDay: null,
    templateEntries: []
  }
}

const getAdditionalEntries = (length, startIndex) => {
  return [...Array(length)].map((_, index) => {
    return {
      name: null,
      displayOrder: startIndex + index
    }
  })
}

const minEntriesCount = 5
const maxEntriesCount = 8

export default {
  name: 'MandalaGoalTemplateForm',
  components: {
    BaseTextFieldGroupWithProvider,
    BaseSelectGroupWithProvider,
    BaseButton,
    CaptionText,
    LabelText,
    MandalaGoalTemplateFormEntryItem,
    LockCheckButton,
    MandalaGoalTemplateFormActivityGoalItem,
    LockFinalGoalNameWrapper,
    MonthlyDeadlineDayField,
    SectionBox,
    SectionBoxLabel,
    ButtonsWrapper,
    EmptyRadarChart,
    LockChartWrapper
  },
  props: {
    /**
     * @description 編集の場合は元となるマンダラ目標テンプレートをpropsで渡す。この有無で編集時のformか登録時のformかを判断する。
     */
    mandalaGoalTemplate: {
      type: Object,
      default: null
    },
    responseErrors: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: getDefaultForm(),
      initialForm: getDefaultForm(),
      entriesCount: 8
    }
  },
  computed: {
    hasMandalaGoalTemplate() {
      return this.mandalaGoalTemplate !== null
    },
    displayEntriesCount() {
      const entriesCount = +this.entriesCount
      if (!entriesCount) {
        return minEntriesCount
      } else if (entriesCount > maxEntriesCount) {
        return maxEntriesCount
      } else if (entriesCount < minEntriesCount) {
        return minEntriesCount
      }
      return entriesCount
    },
    entriesCountOptions() {
      return [5, 6, 7, 8].map(num => {
        return {
          text: num,
          value: num,
        }
      })
    },
    actionGoalsCountOptions() {
      return [3, 4, 5, 6, 7, 8].map(num => {
        return {
          text: num,
          value: num
        }
      })
    }
  },
  watch: {
    displayEntriesCount: {
      handler() {
        this.resetEntries()
      },
      immediate: true
    }
  },
  created() {
    this.initForm()
  },
  methods: {
    initForm() {
      if (this.hasMandalaGoalTemplate) {
        const newForm = cloneDeep(this.mandalaGoalTemplate)
        this.form = newForm
        this.entriesCount = newForm.templateEntries.length
      }
    },
    async submit(status) {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$store.commit('notify/set', { message: '入力内容に不備があります。ご確認の上再度実行してください。', type: 'danger' })
        return
      }

      if (this.isEdit && ['published', 'private'].includes(this.mandalaGoalTemplate.status)) {
        if (!window.confirm('更新内容が今月のテンプレートから反映されます、よろしいですか？')) return
      }
      this.$emit('submit', { ...this.form, status })
    },
    resetEntries() {
      const currentEntriesLength = this.form.templateEntries.length
      const entriesCount = this.displayEntriesCount 
      if (currentEntriesLength > entriesCount) {
        this.form.templateEntries = this.form.templateEntries.slice(0, entriesCount)
      } else {
        const addCount = entriesCount - currentEntriesLength
        this.form.templateEntries = [...this.form.templateEntries, ...getAdditionalEntries(addCount, currentEntriesLength)]
      }
    }
  }
}
</script>

<style>

</style>